// extracted by mini-css-extract-plugin
module.exports = {"description":"Description--description--2tTmk","condensed":"Description--condensed--3bmfr"};